module.exports = __webpack_public_path__ + "static/media/image14.1e4ff44f.jpg";